<template>
  <el-dialog
    style="text-align: center"
    :visible.sync="visible"
    :title="title"
    width="300px">
    <qrcode-vue v-if="qrcode" :value="qrcode" size="180" level="L"></qrcode-vue>
  </el-dialog>
</template>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    qrcode: {
      type: String,
      default: ''
    },
    payWay: {
      type: String,
      default: ''
    },
    orderId: {
      type: Number,
      default: 0
    },
    orderNo: {
      type: String,
      default: ''
    }
  },
  components: {
    QrcodeVue
  },
  data () {
    return {
      timeout: null,
      payed: false,
      visible: false
    }
  },
  methods: {
    open () {
      this.visible = true
    }
  }
}
</script>
